import clsx from "clsx";
import { PartnerBannerProps } from "./PartnerBanner.types";
import Banner from "ui/common/components/display/Banner/Banner";
import { config } from "common/config";
import { useNavigate, useLocation  } from "react-router-dom";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import React from "react";

function PartnerBanner({ className, partner, style, isLoading, size }: PartnerBannerProps) {
    const navigate = useNavigate();
    const location = useLocation();
    return (
        <Banner
            loading={isLoading}
            className={clsx("partner-banner", className)}
            src={partner.banner || partner.logo || config.fallbackImages.partnerBanner}
            alt={`partner-banner-${partner.name.split(" ").join("-").toLowerCase()}`}
            style={style}
            onClick={() => {
                if(location.pathname !== MainRoutes.PARTNER_DETAILS) {
                    navigate(MainRoutes.PARTNER_DETAILS, { state: { partner } });
                };
            }}
            size={size}
        />
    );
}

export default PartnerBanner;
